import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import { getResultadosBusqueda } from "../../Services/busqueda_service";

const initialState = {
  busquedas: [],
};

export const busquedaSlice = createSlice({
  name: "busqueda",
  initialState,
  reducers: {
    setBusquedas: (state, action) => {
      state.busquedas = action.payload;
    },
  },
});

export const fetchBusquedas = createAsyncThunk(
  "busqueda/fetchBusquedas",
  async (_, { dispatch }) => {
    const resultados = await getResultadosBusqueda();
    dispatch(setBusquedas(resultados));
    return resultados;
  }
);

export const { setBusquedas } = busquedaSlice.actions;
export default busquedaSlice.reducer;
